---
en:
  follow_up:
    achived_price: Achived Price
    actual: Actual
    buy_production: Buy production
    cannibalism: Cannibalism
    charts:
      capture_rates: Capture rates
      captured_prices: Captured prices
      consumption: Consumption
      cumulative_production: Cumulative production
      cumulative_total_revenue: Cumulative total revenue
      full_load_factor: Full load factor
      production: Production
      revenue: Revenue
      revenues_phyiscal_financial: Revenues from physical and financial settlements
      revenues_variable_fixed: Revenues from variable and fixed settlements
      risk_and_cannibalism: Risk and cannibalism
      spot_price: Spot price
      volume: Volume
    consumption: Consumption
    consumption_tab:
      paid: Paid
      spot: Spot
    contracted: Contracted
    financial: Financial
    fixed: Fixed
    header: Performance Review
    hedge: Hedge
    index: Index
    merchant: Merchant
    merchant_base_value: Merchant base value
    net: Net value
    overproduction: Overproduction
    overview:
      actual: Actual
      expected: Expected
      full_load_factor: Full load factor
      hedged_price: Hedged price
      hedged_volume: Hedged volume
      production: Production
    p50: p50
    physical: Physical
    ref: Reference
    revenues:
      contracted_sales_revenue: Contracted sales revenue
      fixed_revenues: Fixed revenues
      physical_sales_revenue: Physical sales revenue
      variable_revenues: Variable revenues
    risk:
      overproduction_risk: Overproduction risk
      production_shortfall: Production shortfall risk
    sell_production: Sell production
    shared:
      captured: Captured
      revenue: Revenue
      total: Total
    shortfall: Shortfall
    spot_price: Spot price
    total: Total
    variable: Variable
    volume: Volume
